module.exports = __webpack_public_path__ + "assets/99f40c84ffdb486e6eb4061b4f0a47f6.PNG";